import Link from 'next/link';
import React from 'react';
import { useTheme } from 'styled-components';

import { TQuestionnaireRepayment } from '@/types/questionnaires';

import { TokenService } from '@/shared/api';
import { useTranslate } from '@/shared/hooks/use-translate';
import { DownloadIcon } from '@/shared/ui/icons';
import { priceFormat } from '@/shared/utils/currency';
import { format } from '@/shared/utils/date';

import { StyledDetailsPaymentBillByCash } from '../styled';

type TDetailsPaymentItemProps = {
    bill: TQuestionnaireRepayment;
};

export const DetailsPaymentItem: React.FC<TDetailsPaymentItemProps> = ({ bill }) => {
    const { t } = useTranslate();
    const { color } = useTheme();

    const prepareCheckUrl = (bill: TQuestionnaireRepayment): string => {
        if (bill.method !== 'processingkz') {
            return `${bill?.check_url}?access_token=${TokenService.getAccessToken()}`;
        }
        return bill?.check_url;
    };

    return (
        <StyledDetailsPaymentBillByCash>
            <div>
                <p>
                    <span>{priceFormat(bill.amount, 0)} ₸</span>
                    {bill.method === 'cash'
                        ? t('Оплачено наличными')
                        : bill.method === 'processingkz'
                          ? t('Оплачено картой')
                          : t('paidBy', { method: bill.method })}
                </p>
                <p> {format(bill.created_at)} </p>
            </div>

            <Link href={prepareCheckUrl(bill)} target="_blank">
                <DownloadIcon color={color.primary} />
            </Link>
        </StyledDetailsPaymentBillByCash>
    );
};
